import React__default from 'react';

var InputGroupContext = /*#__PURE__*/React__default.createContext({});

export { InputGroupContext };
